var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-otp"},[_c('span',[_vm._v(_vm._s(_vm.$t('login_otp_translation')))]),(_vm.$t('login_as_client'))?_c('Button',{staticClass:"login-otp__btn",nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('login_as_client')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }